import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { amount, product, renderWarehousePartyNumber } from './form-parts';
import { useService } from '../../../../services/services';
import { useParams } from 'react-router-dom';
import Group from '../../../../components/form/elements/group';
import DealType from '../../../../enums/deal-type';
import Select from '../../../../components/form/elements/select';
import ObtainTypes from '../../../../enums/obtain-types';

let calculationValues = {
  sum: '',
  price: '',
  vat: '',
  sum_with_vat: '',
  amount: '',
  vat_rate: '',
};

export function useUsedProductForm(originalFormValues = null) {
  const { t } = useTranslation();
  const { dealType, farmId } = useParams<{
    dealType: DealType;
    farmId: string;
  }>();

  const { dealService, productService } = useService();

  const [form] = useState(() => [
    Group(
      [
        Select(
          'product_obtain_type_id',
          {
            options: [
              {
                label: t(`classifiers.${ObtainTypes.produced}`),
                value: ObtainTypes.produced,
              },
              {
                label: t(`classifiers.${ObtainTypes.purchased}`),
                value: ObtainTypes.purchased,
              },
              {
                label: t(`classifiers.${ObtainTypes.recycle_gained}`),
                value: ObtainTypes.recycle_gained,
              },
            ],
            label: 'pages.warehouse.deals.product_obtain_type',
          },
          true
        ),
        ...product(
          t,
          dealService,
          productService,
          farmId,
          dealType,
          false,
          false,
          true,
          undefined,
          undefined,
          undefined,
          originalFormValues
        ),
        amount(true, calculationValues, {
          enableNewPartyNumber: true,
          dealService,
          farmId,
          dealType,
          originalFormValues,
        }),
        renderWarehousePartyNumber(),
      ],
      null,
      null,
      false,
      true,
      'no-border-bottom'
    ),
  ]);

  return form;
}

export const usedProductSchema = () => {
  return yup.object().shape({
    product_obtain_type_id: yup.string().required(),
    product_category_id: yup.object().required().shape({
      value: yup.string().required().uuid(),
    }),
    product_type_id: yup.object().required().shape({
      value: yup.string().required().uuid(),
    }),
    product_id: yup.object().required().shape({
      value: yup.string().required(),
    }),
    amount: yup.number().positive().decimal(8, 3).required(),
    product_warehouses: yup
      .array()
      .of(
        yup.object().shape({
          warehouse_id: yup
            .object()
            .shape({
              value: yup.string().required(),
            })
            .required(),
        })
      )
      .min(1)
      .required(),
    unit: yup.object().shape({
      value: yup.string().required(),
    }),
  });
};
